module.exports = __webpack_public_path__ + "img/stack-inserter-platform.866994eb.png";